export enum StreamStatus {
    /**
     * 开始处理，但未获取到数据
     * @description 是客户端标记状态
     */
    PROGRESS_WITHOUT_DATA = 'PROGRESS_WITHOUT_DATA',
    /**
     * 处理中
     * @description 是服务端发送的状态
     */
    PROCESSING = 'PROCESSING',
    /**
     * 完成
     * @description 是服务端发送的状态
     */
    FINISH = 'FINISH',
    /**
     * 中止
     * @description 是客户端标记的状态
     */
    ABORTED = 'ABORTED',
    /**
     * 生成失败
     * @description 是服务端发送的状态
     */
    FAILED = 'FAILED',
}
